import { h } from 'preact';
import { useEffect, useState, useRef } from 'preact/hooks';
import SearchIcon from 'utils/icon/icon-search.svg';
import CloseIcon from 'utils/icon/icon-close.svg';

const PredictiveSearchForm = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const searchInput = useRef(null);
  const form = useRef(null);

  const handleInput = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleClear = () => {
    if (searchInput.current && form.current) {
      form.current.reset();
      searchInput.current.dispatchEvent(new Event('input'));
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (searchInput.current && form.current) {
        form.current.reset();
        searchInput.current.dispatchEvent(new Event('input'));
      }
    }, 300);
  }, []);

  return (
    <div className="h-full flex flex-col">
      <div className="predictive-search-bar py-16 px-24 flex gap-26 items-center border-b border-grey-200">
        <form
          action={`${Shopify.routes.root}search`}
          className="relative input-wrapper flex-1"
          method="get"
          ref={form}
          role="search"
        >
          <input type="hidden" name="type" value="product" />
          <SearchIcon className="w-24 h-auto absolute left-16 top-12" />
          <input
            type="text"
            name="q"
            ref={searchInput}
            value={searchQuery}
            onInput={handleInput}
            placeholder={window.TMW.Strings.search.label}
            className="body-1 lg:body-2 input !py-12 !pl-48 !pr-72 !border-0 bg-grey-300 placeholder-black placeholder:opacity-100"
          />
          {!!searchQuery.length && (
            <button
              type="button"
              onClick={handleClear}
              role="button"
              className="right-16 bottom-14 absolute eyebrow text-subdued !font-semibold"
            >
              {window.TMW.Strings.storeLocator.clear}
            </button>
          )}
        </form>
        <button
          className="w-24 h-24 flex items-center justify-center ml-4 [&>svg]:w-24 [&>svg]:h-24"
          onClick={() =>
            document.dispatchEvent(new CustomEvent('closePredictiveSearch'))
          }
        >
          <CloseIcon />
        </button>
      </div>
      <div
        id="search-results-container"
        className="flex-1 min-h-0 overflow-y-auto overscroll-none"
      ></div>
    </div>
  );
};

export default PredictiveSearchForm;
